
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/[page]",
      function () {
        return require("private-next-pages/settings/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/[page]"])
      });
    }
  